import {
  APPLICATION_NAMES,
  GCLASSROOM,
  GCLASSROOM_HOME,
  GCLASSROOM_INSTRUCTIONS,
  GCLASSROOM_PRIVATE_COMMENTS,
  GCLASSROOM_STUDENT_WORK,
  GDRIVE,
  GDRIVE_GCLASSROOM,
  GFORMS,
  GFORMS_CREATOR,
  GFORMS_RESPONSES
} from '@mote/helpers/constants'
import { getApplicationKey } from './getApplicationKey'
import { normalizeURL } from './normalizeURL'

export const getApplicationView = url => {
  url = normalizeURL(url)
  var key = getApplicationKey(url)
  if (key === '') {
    return ''
  }
  if (key === GDRIVE) {
    if (url.includes('/file/')) {
      return GDRIVE_GCLASSROOM
    }
    return APPLICATION_NAMES[GDRIVE]
  } else if (key !== GCLASSROOM && key !== GFORMS) {
    return key
  } else {
    // log('normalised url: ' + url);
    if (url.includes('/submissions/')) {
      return GCLASSROOM_STUDENT_WORK
    } else if (url.includes('/g/')) {
      return GCLASSROOM_PRIVATE_COMMENTS
    } else if (url.includes('/details')) {
      return GCLASSROOM_INSTRUCTIONS
    } else if (
      (url.includes('/c/') ||
        url.match(/\/h$/) ||
        url.match(/\/u\/\d+\/h$/) ||
        url.match(/u\/\d+\/$/)) &&
      !url.includes('/gb/sort-last-name')
    ) {
      return GCLASSROOM_HOME
    } else if (url.includes('/d/e/')) {
      return GFORMS_RESPONSES
    } else if (url.match('/d/')) {
      return GFORMS_CREATOR
    }
    return ''
  }
}
